import React, { createContext, useContext, useState } from "react";

export const SIDEBAR_EXPANDED_WIDTH = 240;
export const SIDEBAR_COLLAPSED_WIDTH = 72;

interface PlatformSidebarContextType {
  isCollapsed: boolean;
  toggleSidebar: () => void;
}

const PlatformSidebarContext = createContext<PlatformSidebarContextType | undefined>(undefined);

export const PlatformSidebarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const toggleSidebar = () => setIsCollapsed((prev) => !prev);

  return (
    <PlatformSidebarContext.Provider value={{ isCollapsed, toggleSidebar }}>
      {children}
    </PlatformSidebarContext.Provider>
  );
};

export const usePlatformSidebar = (): PlatformSidebarContextType => {
  const ctx = useContext(PlatformSidebarContext);
  if (!ctx) {
    throw new Error("usePlatformSidebar must be used within a PlatformSidebarProvider");
  }
  return ctx;
};